import { useTranslation } from 'react-i18next'
import { useKeycloakInstance, useProfile } from '@dhl/keycloak'
import { Body1, Box, Card, Grid, H5, Link } from '@dhl-ui/components'
import { MDP_ACCESS_REQUEST_URL } from '~/common/config/app-constants'
import { config } from '~/config'
import type { RoleName } from '~/modules/adminusers/model'

export const DashboardPage = () => {
  const { t } = useTranslation()
  const { data: profile } = useProfile()

  const firstName = profile?.firstName === undefined ? 'USER' : profile?.firstName
  const { resourceAccess } = useKeycloakInstance()
  const roles = resourceAccess?.[config.authClient]?.roles as RoleName[] | undefined
  const hasRoles =
    roles?.includes('ADMIN_USERS') ||
    roles?.includes('USERS') ||
    roles?.includes('REPORTS') ||
    roles?.includes('MARKETING') ||
    roles?.includes('ORGANISATIONS') ||
    roles?.includes('TERMINALS') ||
    roles?.includes('CCC') ||
    roles?.includes('REPRINT_LABELS') ||
    roles?.includes('LABEL_REQUESTS') ||
    roles?.includes('PROMOCODES') ||
    roles?.includes('SERVICEPOINT_VENDORS') ||
    roles?.includes('EMAIL_STATUS')

  return (
    <>
      <Grid>
        <Box marginTop={2} marginBottom={3}>
          <H5 data-testid="welcome">{`${t('admin.dashboardPage.titleText')}${firstName}!`}</H5>
        </Box>
      </Grid>
      {!hasRoles && (
        <Grid size={{ sm: 6 }}>
          <Card>
            <Card.Header title={t('admin.dashboardPage.welcomeTitle')} />
            <Card.Content>
              <Grid>
                <Box marginTop={2}>
                  <Body1>{t('admin.dashboardPage.details')}</Body1>
                </Box>
              </Grid>
              <Grid>
                <Box marginTop={2}>
                  <Link
                    title="MDP Access Request"
                    href={MDP_ACCESS_REQUEST_URL}
                    rel="noopener noreferrer"
                    target="_blank"
                    external
                  >
                    {t('admin.dashboardPage.link')}
                  </Link>
                </Box>
              </Grid>
              <Grid>
                <Box marginTop={2}>
                  <Body1>{t('admin.dashboardPage.otherDetails')}</Body1>
                </Box>
              </Grid>
            </Card.Content>
          </Card>
        </Grid>
      )}
    </>
  )
}
